"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureCode = void 0;
var FeatureCode;
(function (FeatureCode) {
    FeatureCode[FeatureCode["PRO"] = 0] = "PRO";
    FeatureCode[FeatureCode["TIME"] = 1] = "TIME";
    FeatureCode[FeatureCode["PTO"] = 2] = "PTO";
    FeatureCode[FeatureCode["AUTO"] = 3] = "AUTO";
    FeatureCode[FeatureCode["CHAT"] = 4] = "CHAT";
})(FeatureCode || (exports.FeatureCode = FeatureCode = {}));
